// extracted by mini-css-extract-plugin
export default {"card":"_3w7RR___ContactCardCTA-module__card","prompt":"_1f0Ss___ContactCardCTA-module__prompt"};